import { defineStore } from "pinia";
import http from "../helper/services/http";
import { ToastFailed, ToastSuccess } from "@/helper/services/toast";
import { useUIStore } from "./ui";
import useMiddleware from "../helper/hooks/useMiddleware";
import useAuthStore from "@/stores/auth"

export default defineStore("user", {
  state() {
    return {
      allUser: [],
      users: [],
      lastFetchTime: {},
      totalUsers: null,
      applications: {},
      topUser: {},
      topSatker: {},
      filterStatusAccount: "",
      filterResponseStatus: ""
    };
  },
  getters: {
    length() {
      return this.users.length;
    },
    limitUser() {
      return () => {
        return this.users;
      };
    },
    pages() {
      return Math.ceil(this.totalUsers !== null ? this.totalUsers / 20 : this.users.length / 20);
    },
    isDataExpired: (state) => (key) => {
      if (!state.lastFetchTime[key]) {
        return true;
      }
      const expirationTime = new Date(
        state.lastFetchTime[key].getTime() + 60 * 60 * 1000
      );
      return expirationTime < new Date();
    },
  },
  actions: {
    getAllUser(
      { limit, offset, forced, keyword, status_account, response_status } = { limit: 20, offset: 0, forced: false, keyword: "", status_account: "", response_status: "" }) {

      const { isAdmin, isSuperAdmin } = useMiddleware();
      if (
        !isAdmin.value &&
        !isSuperAdmin.value &&
        (!this.isDataExpired("getAllUser") || !forced)
      ) {
        return;
      }

      let params = { limit, offset, orderBy: "name", direction: "asc", name: keyword || '' };
      if (keyword) {
        params.search = keyword
      }
      if (status_account) {
        params.status_account = status_account;
      }
      if (response_status) {
        params.response_status = response_status;
      }

      useUIStore().setLoading(true);
      http({ path: "auth" })
        .get("users", { params: params })
        .then(async (res) => {
          // let status = res.data.data.map(async (e) => {
          //   return this.getCertificateStatus(e.nrp);
          // });

          this.allUser = res.data.data;
          this.users = [...this.allUser];
          this.totalUsers = res.data.recordsFiltered;
          // await Promise.all(status)
          //   .then((combinedData) => {
          //     this.allUser.map(
          //       (user, index) => (user.certificate_status = combinedData[index])
          //     );
          //   })
          //   .catch((error) => {
          //     console.error(error);
          //   });
          this.lastFetchTime["getAllUser"] = new Date();
        })
        .catch((err) => {
          ToastFailed.fire({
            icon: "error",
            title: err.message,
          });
        })
        .finally(() => useUIStore().setLoading(false));
    },
    getCertificateStatus(nrp) {
      return http({ path: "auth" })
        .get("esign/status", { params: { nik: nrp } })
        .then((res) => {
          let status;
          switch (res.data.status_code) {
            case 1110:
              status = "Tidak Aktif";
              break;

            default:
              status = "Expired";
              break;
          }
          return status;
        })
        .catch((err) =>
          ToastFailed.fire({ icon: "error", title: err.message })
        );
    },
    getSelectedUser(id, key = null) {
      useUIStore().setLoading(true);
      return http({ path: "auth" })
        .get(`users/${id}`)
        .then((res) => {
          if (key) {
            return res.data.data[key];
          } else {
            return res.data.data;
          }
        })
        .catch(() => {
          return ToastFailed.fire({
            title: "Loading data user, Mohon Tunggu....",
            didOpen: () => {
              ToastFailed.showLoading();
            },
          });
        })
        .finally(() => useUIStore().setLoading(false));
    },
    createUser(data) {
  useUIStore().setLoading(true);

  // 1. Salin data dari parameter 'data' & hapus properti yang tidak didukung BE
  const payload = { ...data };
  delete payload.nama_dengan_gelar;

  http({ path: "auth" })
    .post("users", payload) // 2. Kirim payload yang sudah bersih
    .then(async (res) => {
      this.allUser.push(res.data.data);
      
      // 3. Perbaikan sorting string nama secara alfabetis
      this.allUser.sort((a, b) => (a.name || "").localeCompare(b.name || ""));
      this.users = [...this.allUser];

      if (Array.isArray(data.roles)) {
        for (const role of data.roles) {
          await useAuthStore().changeUserRole(res.data.data.id, role);
        }
      }

      ToastSuccess.fire({
        icon: "success",
        title: "Pengguna berhasil ditambahkan",
      });
    })
    .catch((err) =>
      ToastFailed.fire({
        icon: "error",
        title: err.message,
      })
    )
    .finally(() => {
      this.getAllUser({ limit: 20, offset: 0, forced: true });
      useUIStore().setLoading(false);
    });
},

updateUser(id, data) {
  useUIStore().setLoading(true);

  // Pastikan nama_dengan_gelar juga dibersihkan jika ada di fungsi update
  const formattedData = { ...data };
  delete formattedData.nama_dengan_gelar;

  return http({ path: "auth" })
    .put(`users/${id}`, formattedData)
    .then((res) => {

      const authStore = useAuthStore();
      if (authStore.user?.id === id && res.data?.data) {
        const merged = { ...authStore.user };
        Object.entries(res.data.data).forEach(([key, value]) => {
          if (value !== null && value !== undefined) {
            merged[key] = value;
          }
        });
        authStore.user = merged;
        localStorage.setItem("user", JSON.stringify(authStore.user));
      }

      ToastSuccess.fire({
        icon: "success",
        title: "User berhasil diupdate.",
      });
    })
    .catch((err) => {
      if (err.response?.status === 422) {
        ToastFailed.fire({
          icon: "error",
          title: "Data yang anda masukkan tidak valid.",
        });
      } else {
        ToastFailed.fire({
          icon: "error",
          title: err.message,
        });
      }
    })
    .finally(() => {
      this.getAllUser({ limit: 20, offset: 0, forced: true });
      useUIStore().setLoading(false);
    });
},
    searchUser(keyword, params = {}) {
      useUIStore().setLoading(true);
      
      const queryParams = { 
        ...params, 
        orderBy: "name", 
        direction: "asc"
      };
      
      if (keyword) {
        queryParams.search = keyword;
      }
      if (this.filterStatusAccount) {
        queryParams.status_account = this.filterStatusAccount;
      }
      if (this.filterResponseStatus) {
        queryParams.response_status = this.filterResponseStatus;
      }

      http({ path: "auth" })
        .get(`users`, {
          params: queryParams,
        })
        .then((res) => {
          this.allUser = res.data.data;
          this.totalUsers = res.data.recordsFiltered;
          this.users = [...this.allUser];

        })
        .catch((err) => {
          ToastFailed.fire({
            icon: "error",
            title: err.message,
          });
        })
        .finally(() => useUIStore().setLoading(false));
    },
    async getAllUsersForExport(keyword, status_account, response_status) {
      useUIStore().setLoading(true);
      
      const queryParams = { 
        orderBy: "name", 
        direction: "asc"
      };
      
      if (keyword) {
        queryParams.search = keyword;
      }
      if (status_account) {
        queryParams.status_account = status_account;
      }
      if (response_status) {
        queryParams.response_status = response_status;
      }

      try {
        const res = await http({ path: "auth" }).get(`users`, {
          params: queryParams,
        });
        return res.data.data;
      } catch (err) {
        ToastFailed.fire({
          icon: "error",
          title: err.message,
        });
        return [];
      } finally {
        useUIStore().setLoading(false);
      }
    },
    deleteUser(id) {
      useUIStore().setLoading(true);
      http({ path: "auth" })
        .delete(`users/${id}`)
        .then(() => {
          this.allUser = this.allUser.filter((user) => user.id !== id);
          this.users = this.users.filter((user) => user.id !== id);
          ToastSuccess.fire({
            icon: "success",
            title: "User berhasil dihapus.",
          });
        })
        .catch((err) =>
          ToastFailed.fire({
            icon: "error",
            title: err.message,
          })
        )
        .finally(() => useUIStore().setLoading(false));
    },
    resetPasswordUser(id) {
      useUIStore().setLoading(true);
      http({ path: "auth" })
        .post(`users/reset-password-to-default`, { user_id: id })
        .then(() => {
          ToastSuccess.fire({
            icon: "success",
            title: "Password pengguna berhasil direset kembali menjadi NRP",
          });
        })
        .catch((err) =>
          ToastFailed.fire({
            icon: "error",
            title: err.message,
          })
        )
        .finally(() => useUIStore().setLoading(false));
    },
    registerBSRE(body) {
      useUIStore().setLoading(true);
      let data = new FormData();
      for (let [key, value] of Object.entries(body)) {
        data.append(`${key}`, value);
      }
      http({ path: "auth" })
        .post("esign/registrasi", data)
        .then((res) => {
          ToastSuccess.fire({
            icon: "success",
            title: res.data.message,
          });
        })
        .catch((err) => {
          ToastFailed.fire({
            icon: "error",
            title: err.message,
          });
        })
        .finally(() => useUIStore().setLoading(false));
    },
    async searchUserNRP(nrp) {
      useUIStore().setLoading(true);
      return http({ path: "auth" })
        .get("sipp", { params: { nrp } })
        .then((res) => {
          return res.data;
        })
        .catch((err) => {
          ToastFailed.fire({
            icon: "error",
            title: err.message,
          });
        })
        .finally(() => useUIStore().setLoading(false));
    },
    loadUserApps() {
      useUIStore().setLoading(true)
      return http({ path: "auth" })
        .get("applications")
        .then((res) => {
          this.applications = res.data.data
        })
        .finally(() => useUIStore().setLoading(false))
    },
    loadTopUser(start_date, end_date) {
      useUIStore().setLoading(true);
      return http({ path: "auth" })
        .get('users/usage', { params: start_date && end_date ? { start_date, end_date } : '' })
        .then((res) => {
          this.topUser = res.data.data
        })
        .finally(() => useUIStore().setLoading(false));
    },
    loadTopSatker(start_date, end_date) {
      useUIStore().setLoading(true);
      return http({ path: "auth" })
        .get('organizations/usages', { params: start_date && end_date ? { start_date, end_date } : '' })
        .then((res) => {
          this.topSatker = res.data.data
        })
        .finally(() => useUIStore().setLoading(false));
    },
  },
});